import { AppRoutes } from '../../app/constants'
import useRouteMatch from '../../app/hooks/useRouteMatch'

const GiftCardShareKeyPattern = '[a-zA-Z0-9]{5}'

export default function useIsGiftCardPreviewRoute() {
  const isGiftCardPreviewRoute = useRouteMatch([AppRoutes.GiftCardPreview], {
    variablePattern: GiftCardShareKeyPattern,
    exactMatch: true,
  })

  return isGiftCardPreviewRoute
}
